// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { Col, Row, List } from 'antd'
import { CameraActivityCircle } from 'components/camera-activity-circle'
import HealthTag from 'components/HealthTag'
import { MultipleSelectionModel } from '../../utils/multiple-selection-model'
import classnames from 'classnames'

export interface ICameraListItemProps {
  index: number
  item: any
  selectionModel: MultipleSelectionModel
  onMouseEnter: (item: any, index: number) => void
}

export interface ICameraListItemState {
  isSelected: boolean
}

export class CameraListItem extends React.Component<ICameraListItemProps, ICameraListItemState> {
  constructor (props) {
    super(props)
    this.state = {
      isSelected: props.selectionModel.isSelected(props.index)
    }
  }

  componentDidMount () {
    const { selectionModel } = this.props
    selectionModel.emitter.on('change', this.handleSelectionChange)
  }

  componentWillUnmount () {
    const { selectionModel } = this.props
    selectionModel.emitter.off('change', this.handleSelectionChange)
  }

  private handleSelectionChange = () => {
    const { selectionModel, index } = this.props
    const isSelected = selectionModel.isSelected(index)
    if (isSelected !== this.state.isSelected) {
      this.setState({
        isSelected
      })
    }
  }

  private handleMouseEnter = e => {
    const { onMouseEnter, item, index } = this.props
    onMouseEnter(item, index)
  }

  render () {
    const { index, item } = this.props
    const classname = classnames('camera-finder-list-item', {
      selected: this.state.isSelected
    })
    return (
      <List.Item data-selection-index={index} className={classname} onMouseEnter={this.handleMouseEnter}>
        <List.Item.Meta
          title={
            <Row justify='space-between' align='middle'>
              <Col>
                ID&nbsp;{item.deviceID}&nbsp;
                <CameraActivityCircle status={item.onlineStatus} />
              </Col>
              <Col>
                <HealthTag status={item.status} />
              </Col>
            </Row>
          }
        />
      </List.Item>
    )
  }
}
